var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#ff6633"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5 18H22.5V22.5H24.5V18ZM26.5 19.5V16.5C26.5 15.6716 25.6046 15 24.5 15H22.5C21.3954 15 20.5 15.6716 20.5 16.5V19.5H17.5C16.6716 19.5 16 20.1716 16 21V24.75V28.5V30V33.75V35.25V40.5C16 41.3284 16.6716 42 17.5 42H41.5C42.3284 42 43 41.3284 43 40.5V35.25V33.75V30V28.5V24.75V21C43 20.1716 42.3284 19.5 41.5 19.5H38.5V16.5C38.5 15.6716 37.6046 15 36.5 15H34.5C33.3954 15 32.5 15.6716 32.5 16.5V19.5H26.5ZM40 28.5V24.75H36.25V28.5H40ZM34.75 28.5V24.75H30.25V28.5H34.75ZM28.75 28.5H24.25V24.75H28.75V28.5ZM28.75 30V33.75H24.25V30H28.75ZM30.25 33.75V30H34.75V33.75H30.25ZM28.75 35.25H24.25V39H28.75V35.25ZM30.25 39V35.25H34.75V39H30.25ZM36.25 35.25V39H40V35.25H36.25ZM36.25 30V33.75H40V30H36.25ZM22.75 28.5V24.75H19V28.5H22.75ZM19 30H22.75V33.75H19V30ZM19 39V35.25H22.75V39H19ZM36.5 18V22.5H34.5V18H36.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.355e379834e4d9f4d7079a19a95d946d.svg";
export { ForwardRef as ReactComponent };